import { render, staticRenderFns } from "./location-view.vue?vue&type=template&id=42333516&scoped=true"
import script from "./location-view.vue?vue&type=script&lang=js"
export * from "./location-view.vue?vue&type=script&lang=js"
import style0 from "./location-view.vue?vue&type=style&index=0&id=42333516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42333516",
  null
  
)

export default component.exports